import React, { useEffect, useState } from "react";
import "../../Styles/Admin.css";
import group from "../../assets/group.png";
import programmer from "../../assets/programmer.png";
import manavatar from "../../assets/man-avatar.png";
import approved from "../../assets/5202151.png";

import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import axios from "axios";
import Loader from "../../Components/Loader"

// Register Chart.js elements
ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

function Home() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [facultyData, setFacultyData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [approvedUsers, setApprovedUsers] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        setError("No auth token found. Please log in.");
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get("https://api.uniums.com/api/admin/admin-dashboard", {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        setFacultyData(response.data.data.faculty);
        setStudentData(response.data.data.students);
        setBlockedUsers(response.data.data.blockedUsers);
      } catch (err) {
        setError(err.response?.data?.error || "An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchApprovedUsers = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        setError("No auth token found. Please log in.");
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get("https://api.uniums.com/api/admin/admin-approved-users", {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.data.success) {
          setApprovedUsers(response.data.approvedUsers);
        } else {
          setError(response.data.message || "Failed to fetch approved users.");
        }
      } catch (err) {
        setError(err.response?.data?.error || "An error occurred while fetching approved users.");
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedUsers();
  }, []);


  const formattedTime = currentTime.toLocaleString();

  const pieData = {
    labels: ["Faculty", "Students"],
    datasets: [
      {
        data: [facultyData.length, studentData.length],
        backgroundColor: ["#4CAF50", "#FF9800"],
        borderColor: ["#4CAF50", "#FF9800"],
        borderWidth: 1,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  const barData = {
    labels: ["Users"],
    datasets: [
      {
        label: "Block User",
        data: [blockedUsers.length],
        backgroundColor: "#FF5252",
        borderColor: "#FF5252",
        borderWidth: 1,
      },
      {
        label: "Students",
        data: [studentData.length],
        backgroundColor: "#2196F3",
        borderColor: "#2196F3",
        borderWidth: 1,
      },
      {
        label: "Faculty",
        data: [facultyData.length],
        backgroundColor: "#4CAF50",
        borderColor: "#4CAF50",
        borderWidth: 1,
      }
    ],
  };

  const barOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container">
      <div className="marquee-container">
        <div className="marquee">
          Welcome to UNIUMS ADMIN | Current Time: {formattedTime}
        </div>
      </div>

      <div className="cards-container">
        <div className="card">
          <img src={group} alt="Total Users" className="card-image" />
          <div className="card-content card-content-admin">
            <h3 className="card-title">Total Users</h3>
            <p className="card-number">{facultyData.length + studentData.length}</p>
          </div>
        </div>
        <div className="card">
          <img src={programmer} alt="Faculty" className="card-image" />
          <div className="card-content card-content-admin">
            <h3 className="card-title">Faculty</h3>
            <p className="card-number">{facultyData.length}</p>
          </div>
        </div>
        <div className="card">
          <img src={manavatar} alt="Students" className="card-image" />
          <div className="card-content card-content-admin">
            <h3 className="card-title">Students</h3>
            <p className="card-number">{studentData.length}</p>
          </div>
        </div>
        <div className="card">
          <img src={approved} alt="Students" className="card-image" />
          <div className="card-content card-content-admin">
            <h3 className="card-title">Users Limit</h3>
            <p className="card-number">{approvedUsers}</p>
          </div>
        </div>
      </div>

      <div className="card graph_cards">
        <div className="charts-container">
          <div className="chart-card">
            <h3>Faculty Percentage</h3>
            <Pie data={pieData} options={pieOptions} />
          </div>
        </div>
        <div className="chart-container">
          <h3>Users Statistics</h3>
          <div className="chart-wrapper">
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
